@use "../../../../styles/responsive";

$component-name: "readonly-list-item";

.readonlyListItem {
  --ixf-readonly-list-item-min-height: 48px;
  //--ixf-readonly-list-item-background: var(--ixf-color-background);
  --ixf-readonly-list-item-background: transparent;
  --ixf-readonly-list-item-padding: 15px 0;

  width: 100%;
  min-height: var(--ixf-readonly-list-item-min-height);
  display: flex;
  align-items: center;
  background: var(--ixf-readonly-list-item-background);

  &.withLastChildBorder,
  &:not(:last-child) {
    border-bottom: 1px solid var(--ixf-color-separator);

    &:has(+ .isAggregate) {
      border-bottom: 1px solid var(--ixf-text-tone-md);
    }
  }

  &.isAggregate {
    border-top: 1px solid var(--ixf-text-tone-md);
  }

  &.hideOverflow {
    overflow: hidden;
  }

  .container {
    width: 100%;
  }

  .content {
    width: 100%;
    overflow: visible;

    > * {
      min-width: 0;
      flex-shrink: 1;
      flex-basis: auto;
      flex-grow: 0;
    }

    @include responsive.responsive-props(
      $component-name,
      "padding-left",
      "padding-left"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-right",
      "padding-right"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-top",
      "padding-top"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-bottom",
      "padding-bottom"
    );

    svg {
      height: 16px;
    }
  }

  .leftContentContainer {
    flex: 1 1 min-content;
    min-width: min-content;

    * {
      white-space: normal;
    }
  }

  .rightContentContainer {
    &.singleColumn {
      width: 100%;
    }

    min-width: 0;
    flex: 0 1 auto;
    overflow-wrap: break-word;

    *:not(button) {
      min-width: 0;
    }
  }

  .pillActionContainer {
    flex-shrink: 0;
    overflow-wrap: normal;
  }

  .skeleton {
    display: flex;
    height: 100%;

    .short,
    .long {
      z-index: 0;
      height: 0.875rem;
    }

    .short {
      width: 64px;
    }

    .long {
      width: 96px;
    }
  }
}
